import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/HomePage";
import authRoutes from "./authRoutes";
import NotFound from "../pages/NotFound";
import TermsPage from "../pages/Terms";
import driverRoutes from "./driverRoutes";

const index = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/*",
    element: <NotFound />,
  },
  ...authRoutes,
  ...driverRoutes,
]);

export default index;
